import React from 'react';
import { styled } from '@elliemae/ds-system';
import { OpenWindow as OpenWindowIcon, type SvgIconT } from '@elliemae/ds-icons';

const StyledOpenWindow = styled(OpenWindowIcon)`
  cursor: pointer;
  :focus {
    outline: 1px solid ${(props) => props.theme.colors.brand[800]};
  }
`;

export const OpenWindow = (props: SvgIconT.Props): JSX.Element => (
  <StyledOpenWindow size="s" color={['brand-primary', '800']} {...props} />
);

export default OpenWindow;
